import api from './client'

export interface ActiveCheckIn {
  id: string
  userId: string
  diveSiteId?: string | null
  diveSiteName?: string | null
  country?: string | null
  startedAt: string
  plannedEndAt?: string | null
  status: string
}

export const checkInApi = {
  getActive: () =>
    api.get<ActiveCheckIn | null>('/v1/dives/check-in/active', {
      validateStatus: (s) => s === 200 || s === 404,
    })
      .then((r) => r.status === 404 ? null : r.data)
      .catch(() => null),

  checkout: (id: string) =>
    api.patch(`/v1/dives/check-in/${id}/check-out`).then((r) => r.data),
}
